<template>
  <div>
    <div class="row  mt-3">
      <div class="col-12 mb-3">
        <button class="btn btn-default btn-block" @click="$router.push('/improvements/create?jobId='+job.id)">
          <i class="fas fa-plus"></i>
          {{ $t('improvements.improvement.improvement') }}
        </button>
      </div>
      <div class="col-12" id="progress-bar-detail"
           v-html="getProductivityProgressBar(job,getConfig,false)"/>
    </div>
    <div class="row  mt-3">

      <div class="col-sm-12   col-lg-9 mt-3">
        <h3 style="color: black;">{{ $t('jobs.detail.timeSpentVsTarget') }} </h3>
        <p style="font-size:20px;">
          {{ convertMs(getJobNumbers.timeSpent).hrs }}:{{
            convertMs(getJobNumbers.timeSpent).min
          }}:{{ convertMs(getJobNumbers.timeSpent).sec }}
          /<strong>
          {{ convertMs(getJobNumbers.target).hrs }}:{{
            convertMs(getJobNumbers.target).min
          }}:{{ convertMs(getJobNumbers.target).sec }}
        </strong>
          <br>
          <small>  {{  convertMs(getJobTotalExplainedLogs(job.id)).hrs }}:{{ convertMs(getJobTotalExplainedLogs(job.id)).min }}
            {{ $t('jobs.detail.explainedByLogs') }}</small>
        </p>
      </div>
      <div class=" col-sm-12  col-lg-3 mt-3  ">
        <button @click="savePerformanceLog()" class="btn btn-success float-right">{{ $t('jobs.savePerformanceLog') }}</button>
      </div>

      <div class="col-sm-12 col-lg-12   mt-3">
        <div class="form-group">

          <label for="job-remark">{{ $t('jobs.detail.remark.label') }}</label>
          <textarea name="job-remark" v-model="comment.remark.text" id="job-remark" cols="30" rows="6"
                    class="form-control"></textarea>
        </div>
      </div>
      <div class="col-sm-12 col-lg-12 col mt-3">
        <JobReasonLog v-if="getReasonsForJob" :reasonIndexWarning="reasonIndexWithWarning" :job="job"></JobReasonLog>
      </div>


      <!--      <div class="col-sm-12 col-lg-6 col mt-3 ">-->
      <!--        <h3 class="mt-3">{{$t('jobs.detail.detailTitle')}}</h3>-->
      <!--        <label for=""> &nbsp;</label>-->
      <!--        <b-card>-->


      <!--          <div class="table-responsive">-->
      <!--            <table class="table  w-100">-->
      <!--              <tbody>-->
      <!--              <template v-for="(value, propertyName,idx) in getJobDetails">-->
      <!--                <tr :key="idx">-->
      <!--                  <td><strong>{{getPropertyName(propertyName)}}</strong></td>-->
      <!--                  <td>{{getValueType(value)}}</td>-->
      <!--                </tr>-->
      <!--              </template>-->
      <!--              </tbody>-->
      <!--            </table>-->
      <!--          </div>-->
      <!--        </b-card>-->
      <!--      </div>-->

    </div>

  </div>

</template>

<script>
import {mapGetters} from 'vuex';
//mixins
import timeCalc from '../../mixins/timeCalc';
import createImprovement from '@/mixins/improvements/createImprovement';
import JobReasonLog from "@/components/jobs/JobReasonLog";
// @vuese
// @group JobDetail
// This component shows the current and historical productionRuns of currently showing jo
export default {
  name: 'PerformanceLog',
  components: {JobReasonLog},
  mixins: [timeCalc, createImprovement],
  props: {
    //@vuese
    // Passed in job to get the productionRuns from
    job: {
      required: true,
      type: Object,
      default: null
    },
  },
  data() {
    return {
      remarkChanged: false,
      suggestionChanged: false,
      reasonIndexWithWarning: [],
      comment: {
        remark: {
          text: '',
          by: []
        },
        suggestion: {
          text: '',
          by: []
        }
      },
      productList: false
    };
  },
  computed: {
    ...mapGetters([
      'getTime'
    ]),
    ...mapGetters('company', [
      'getConfig'
    ]),
    ...mapGetters('users', [
      'getMe',
      'getClaims'
    ]),
    ...mapGetters('jobs',['getJobTotalExplainedLogs']),
    ...mapGetters('reasonTrees', ['getReasonTrees']),
    ...mapGetters('productionRuns', [
      'getProductionRunsOfJob',
      'getProductionRunsOfWorkflow',
      'getProducedAmountOfOrderlineId',
      'getProducedAmountOfOrderId',
      'getProducedAmountOfJobId',
      'getProductivityProgressBar'
    ]),
    ...mapGetters('downTimes', ['getDownTimesForJob']),

    getReasonsForJob() {
      let reasons = _.filter(this.getReasonTrees, reasonTree => {
        if (reasonTree.type === 'job') {
          return this.job.department === reasonTree.department || !this.job.department
        }
      })
      return reasons[0]
    },
    //@vuese
    // gets the current time spent
    // this is updated every second
    getJobWithCalculatedTimeSpent() {
      const self = this;
      let job = this.job;
      job.calculatedTimeSpent = job.timeSpent ? job.timeSpent : 0;
      let downtimes = this.getDownTimesForJob(this.job.id);
      let totalTime = 0
      for (let i = 0; i < downtimes.length; i++) {
        let downtime = downtimes[i]
        if(downtime.type == 'out-planned' || downtime.excludeFromProductivity){
          let diff = moment(downtime.downTimeEnded).diff(downtime.downTimeIndicator)
          console.log(diff)
          totalTime+=diff
        }
      }
      job.calculatedTimeSpent = job.calculatedTimeSpent - (totalTime);

      let productionRuns = this.getProductionRunsOfJob(job.id);

      let currentlyRunning = _.filter(productionRuns, run => {
        return !run.productionEnd;
      });

      let totalDiff = _.reduce(currentlyRunning, function (sum, n) {
        let diff = self.getTime.diff(moment(n.productionStart));
        return sum + diff;
      }, 0);
      job.calculatedTimeSpent += totalDiff;
      return job;
    },
    //@vuese
    // Get job details to render, except given keys.
    // @type Object
    getJobDetails() {
      let jobDetails = _.omit(this.job, ['products', 'workflowStates', 'status', 'amount', 'amountProduced', 'companyId', 'id', 'target', 'timeSpent', 'uid', 'finishedBy', 'comment']);
      return _.pickBy(jobDetails, _.identity);
    },
    // @vuese
    // Get job details about the numbers this job totally produced.
    //`{target:0,timeSpent:0,amount:0,amountProduced:0}`
    // @type  Object
    getJobNumbers() {
      let jobDetails = this.getJobWithCalculatedTimeSpent;


      return {
        target: jobDetails.target,
        timeSpent: jobDetails.calculatedTimeSpent ? jobDetails.calculatedTimeSpent : 0,
        amount: jobDetails.amount,
        amountProduced: jobDetails.amountProduced
      };
    },
    // @vuese
    // returns the product list
    // @type Array
    getJobProducts() {
      return this.job.products;
    },
    // @vuese
    // @type Array
    // Generates custom headers for the product data
    uniqueHeadersFromAdditionalData() {
      let productAdditionalData = [];
      _.each(this.getJobProducts, p => {
        productAdditionalData.push(p.additionalData);
      });
      return Object.keys(Object.assign({}, ...productAdditionalData));
    },
    //@vueese
    // calculates the time spent left
    getJobTimeSpentLeft() {
      let millisLeft = this.job.timeSpent - this.job.target;
      return {
        exceeded: millisLeft > 0,
        timeLeft: this.convertMs(millisLeft)
      };
    }
  },
  methods: {

    getPropertyName(value) {
      return _.startCase(value);
    },
    // @vuese
    // Gets the type of data, if its a object and has toDate propery, then its a firebase timestamp else returns the raw data
    getValueType(data) {
      if (typeof data == 'object' && Object.getPrototypeOf(data).hasOwnProperty('toDate')) {
        let format = 'DD/MM/YY';
        return moment(data.toDate()).utc().format(format);
      } else {
        return data;
      }
    },
    checkReasons() {
      _.each(this.job.logs, (log, idx) => {
        if (log.timeInMs < 1 || !log.reason) {
          this.reasonIndexWithWarning.push(idx)
        } else {
          this.reasonIndexWithWarning.splice(idx, 1)
        }

      })
      return !this.reasonIndexWithWarning.length;

    },
    // @vuese
    // Save comments if comment data  has changed based since load
    //  saving comments sets has changed to false
    savePerformanceLog() {
      let comment = this.comment;
      if (this.remarkChanged) {
        comment.remark.by.push({
          timeStamp: new Date(),
          userName: this.getMe.displayName ? this.getMe.displayName : this.getMe.email
        });
      }

      if (!this.checkReasons()) {
        return
      }

      return this.$store.dispatch('jobs/set', {
        id: this.job.id,
        logs: this.job.logs ? this.job.logs : [],
        comment
      }, {merge: true}).then(res => {
        this.remarkChanged = false;
        this.swalToastSuccess(this.$t('jobs.detail.saved'));
      });
    }
  },
  watch: {
    'comment.remark.text': {
      handler: function () {
        this.remarkChanged = true;
      }
    },
    'comment.suggestion.text': {
      handler: function (newV, oldV) {
        this.suggestionChanged = true;
      }
    }
  },
  created() {
    if (this.job.comment) {
      this.comment = JSON.parse((JSON.stringify(this.job.comment)));
    } else {
      this.$store.dispatch('jobs/patch', {id: this.job.id, comment: this.comment}).catch(e => {
      });
    }

  }
};
</script>

<style scoped lang="scss">
tr:first-child td {
  border-top: 0;
}

label {
  font-size: 1.8rem;
  color: #000;
  font-weight: 600;
}

.btn-default {
  color: #333;
  background-color: #e9ecef;
  border: 1px solid transparent;
  border-radius: 0;
  line-height: 1.5;
  padding: 1.1rem 2.5rem;
  font-size: 1.4rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  cursor: pointer;
  transition: color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;

  &:hover {
    color: #333;
    background-color: #dee2e6;
    border-color: transparent;
  }

  &:focus,
  &.focus {
    color: #333;
    background-color: #dee2e6;
    border-color: #00c9ff;
    box-shadow: 0 0 0 0.2rem rgba(0, 201, 255, 0.25);
  }

  &:active,
  &.active {
    color: #333;
    background-color: #dee2e6;
    border-color: #00c9ff;
    box-shadow: 0 0 0 0.2rem rgba(0, 201, 255, 0.5);
  }
}
</style>
